import React, { useEffect } from 'react';
import { Box, Text } from '@indeed/ifl-components';
import { usePageFlow } from '../../lib/pageFlow/usePageFlow';

const DefaultApplyIndexPage: React.FunctionComponent = () => {
    const { goForward, loading } = usePageFlow();

    // Use flow-aware navigation to first step
    useEffect(() => {
        // When users explicitly navigate to /default-apply, use intelligent flow navigation
        // goForward() will handle navigation to the appropriate first step
        if (!loading) {
            void goForward({ replace: true });
        }
    }, [goForward, loading]);

    // Loading state while redirecting
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minBlockSize: '60vh',
                flexDirection: 'column',
                gap: 4,
            }}
        >
            <Text sx={{ fontSize: 3, fontWeight: 'bold' }}>🔄 Starting Default Apply...</Text>
            <Text sx={{ color: 'foreground.secondary' }}>
                Redirecting to your full-featured application experience
            </Text>
        </Box>
    );
};

export default DefaultApplyIndexPage;
